/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfituse2Inputs */

const en_coverfituse2 = /** @type {(inputs: Coverfituse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as cover`)
};

const de_coverfituse2 = /** @type {(inputs: Coverfituse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Titelbild verwenden`)
};

/**
* | output |
* | --- |
* | "Use as cover" |
*
* @param {Coverfituse2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfituse2 = /** @type {((inputs?: Coverfituse2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfituse2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfituse2(inputs)
	return de_coverfituse2(inputs)
});
export { coverfituse2 as "coverFitUse" }